"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = process_duration;
exports.formatDuration = formatDuration;

function process_duration(duration, direction, baseDate) {
  try {
    var d = JSON.parse(duration || 0);

    if (typeof d == 'number') {
      d = {
        count: d,
        unit: 'minute'
      };
    }

    if (babelHelpers.typeof(d) == 'object') {
      if ('count' in d && 'unit' in d) {
        var m = {
          second: 'Seconds',
          minute: 'Minutes',
          day: 'Date',
          month: 'Months',
          year: 'FullYear'
        };
        var dd = new Date();
        if (baseDate) dd.setTime(baseDate.getTime());
        dd["set".concat(m[d.unit])](dd["get".concat(m[d.unit])]() + direction * d.count);
        return dd;
      }
    }
  } catch (e) {
    ;
  }

  return null;
}

function formatDuration(duration) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'min';
  var d0 = new Date();
  var d1 = new Date(d0.getTime());
  d1 = process_duration(value, 1, d1);
  var diffSec = (d1.getTime() - d0.getTime()) / 1000;
  diffSec = Math.round(diffSec);
  var sec = diffSec % 60;
  var diffMin = (diffSec - sec) / 60;
  if (unit == 'min' || diffMin < 60) return "".concat(diffMin, " min");
  var min = diffMin % 60;
  var diffHour = (diffMin - min) / 60;

  if (unit == 'hour' || diffHour < 24) {
    var d = diffHour * 2;
    d += Math.round(min / 30);
    d /= 2;
    return "".concat(d, " hr").concat(d == 1 ? '' : 's');
  }

  var hour = diffHour % 24;
  var diffDay = (diffHour - hour) / 24;

  if (unit == 'day' || diffDay < 30) {
    return "".concat(diffDay, " day").concat(diffDay != 1 ? 's' : '');
  }

  if (unit == 'month' || diffDay < 365) {
    var months = Math.round(diffDay / 15) / 2;
    return "".concat(months, " month").concat(months != 1 ? 's' : '');
  }

  var years = Math.round(diffDay / (.5 * 365)) / 2;
  return "".concat(years, " year").concat(years == 1 ? '' : 's');
}